import assetPath from '/opt/actions-runner/_work/crate/crate/brewery-packages/xds/fonts/assets/XING-Sans-Bold.woff2';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')